<template>
    <page title="recordSetsTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <v-col cols="12" md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="RecordSets"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.recordSetsLoading')"
                            :server-items-length="RecordSets.length"
                            hide-default-footer
							:height="WindowSize.y - 380"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="3" lg="2">
                                            <v-btn-toggle dense color="primary">
                                                <v-btn
                                                    color="primary"
                                                    @click="newRecordSet">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newRecordSet`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
										<v-col cols="12" sm="7" lg="8">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.freetextSearch"
                                                :label="$t('text.name')"
                                                @keyup.enter.native="search">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" lg="2"
											align="right">
                                            <v-btn-toggle dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="edit(item.id)">
                                            <v-icon>
                                                edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.edit`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="requestDelete(item.id)">
                                            <v-icon>
                                                delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.delete`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="getRecordSet(item.id)">
                                            <v-icon>
                                                mdi-clipboard-list-outline
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.recordsTitle`) }}</span>
                                </v-tooltip>
                            </template>
                            <template #[`item.name`]="{ item }">
                                {{ `${item.name}(${item.code})` }}
                            </template>
                            <template #[`item.recordValidity`]="{ item }">
                                {{ getRecordValidityLable(item) }}
                            </template>
                        </v-data-table>

                        <pagination
                            :currentPage="RecordSetPagination.currentPage"
                            :totalPages="RecordSetPagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>
			<pop-up v-model="confirmReturn"
				:show="showConfirm"
				text="deleteRequest"
				:title="null"
				type="confirm"
				@change="callOnConfirmDelete"
				:props="{id: requestDeleteId}"></pop-up>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';
import PopUp from '../general/PopUp.vue';

import recordsActions from '../store/actions/records';
import namespace from '../store/namespace';

import getRecordValidity from '../models/recordValidity';

class TempRecordSetQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
		}
	}
}

class RecordSetQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.freetextSearch = '';
		}
	}

	updateTempData(tempQP) {
		this.freetextSearch = tempQP.freetextSearch;
	}
}

export default {
	name: 'Recordsets',
	components: {
		Page,
		Pagination,
		PopUp,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: '156px',
				},
				{
					text: this.$i18n.t('text.headerRecordSetName'), align: 'left', value: 'name', sortable: false,
				},
				{
					text: this.$i18n.t('text.class'), align: 'left', value: 'nationalClassShort', sortable: false,
				},
				{
					text: this.$i18n.t('text.recordValidityLable'), align: 'left', value: 'recordValidity', sortable: false,
				},
			],
			loading: true,
			queryParameters: new RecordSetQueryParameter(),
			tempQP: new TempRecordSetQueryParameter(),
			// queryParameters: {
			// 	pageNumber: 1,
			// 	pageSize: 10,
			// 	freetextSearch: '',
			// },
			showConfirm: false,
			confirmReturn: 0,
			requestDeleteId: null,
			help: [
				{
					icon: 'mdi-clipboard-list-outline',
					text: this.$t('text.recordsTitle'),
				},
				{
					icon: 'delete',
					text: this.$t('text.delete'),
				},
				{
					icon: 'edit',
					text: this.$t('text.edit'),
				}],
		};
	},
	async mounted() {
		if (localStorage.getItem('recordSetsApp')) {
			this.queryParameters = new RecordSetQueryParameter(JSON.parse(localStorage.getItem('recordSetsApp')));
			this.tempQP = new TempRecordSetQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('recordSetsApp', JSON.stringify(this.queryParameters));
		}
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		...mapGetters(namespace.RECORDS, ['RecordSetLinks', 'RecordSets', 'RecordSetPagination']),
		nonContentPage() {
			return this.RecordSets.length == 0;
		},
		recordValidity() {
			return getRecordValidity(this);
		},
	},
	watch: {
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('recordSetsApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.RECORDS, [
			recordsActions.GET_RECORDSET_LINKS,
			recordsActions.GET_RECORDSETS,
			recordsActions.DELETE_RECORDSET,
		]),
		async getRecordSetLinks() {
			try {
				await this.GET_RECORDSET_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('recordSetsApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		async loadData() {
			this.loading = true;
			if (!this.RecordSetLinks.length) {
				await this.getRecordSetLinks();
			}
			try {
				const recordSetRequest = {
					masterOrgId: this.Organization,
					queryParameters: this.queryParameters,
				};

				await this.GET_RECORDSETS(recordSetRequest);
				if (this.nonContentPage) {
					this.queryParameters.pageNumber = this.RecordSetPagination.totalPages;
				}
			} finally {
				this.loading = false;
			}
		},
		getRecordValidityLable(item) {
			return this.recordValidity.find(x => x.value === item.recordValidity).text + ((item.recordValidity !== 1) ? `(${item.validityQualifier})` : '');
		},
		async pageSizeChanged(newPageSize) {
			this.queryParameters.pageSize = newPageSize;
			const maxPage = Math.ceil(this.RecordSetPagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.RecordSetPagination.currentPage ? maxPage : this.RecordSetPagination.currentPage;

			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;

			await this.loadData();
		},
		newRecordSet() {
			this.$router.push({
				name: 'newrecordset',
			});
		},
		getRecordSet(id) {
			this.$router.push({
				name: 'records',
				params: {
					id,
				},
			});
		},
		async edit(id) {
			this.$router.push({
				name: 'updaterecordset',
				params: {
					id,
				},
			});
		},
		requestDelete(id) {
			this.requestDeleteId = id;
			this.showConfirm = true;
		},
		async callOnConfirmDelete(value, props) {
			if (value === 1) {
				this.showConfirm = false;
				this.loading = true;
				try {
					await this.DELETE_RECORDSET(props.id);
					await this.loadData();
				} catch (ex) {
					console.log(ex);
				}

				this.loading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.new-competition {
    span {
        font-size: .675rem !important;
    }
}

.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
